import { __decorate } from 'tslib';
import { unsafeCSS, css, LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import clsx from 'clsx';
import css_248z from './avatar.styles.css.js';
import { getBgColorClass } from '../../types/bgColors.js';

/**
 * Avatar Component.
 *
 * @element ht-avatar
 */
let HTAvatar = class HTAvatar extends LitElement {
    constructor() {
        super(...arguments);
        this.image = null;
        this.fallback = null;
        this.size = 'small';
        this.roundness = 'small';
        this.imgAlt = '';
        this.objectFit = 'cover';
        this.bgColor = 'transparent';
        this.bordered = false;
    }
    get computedClasses() {
        return clsx('avatar', {
            '--size-small': this.size === 'small',
            '--size-medium': this.size === 'medium',
            '--size-medium-plus': this.size === 'mediumPlus',
            '--size-large': this.size === 'large',
            '--size-huge': this.size === 'huge',
            '--size-massive': this.size === 'massive',
            '--size-fluid': this.size === 'fluid',
            '--roundness-none': this.roundness === 'none',
            '--roundness-tiny': this.roundness === 'tiny',
            '--roundness-small': this.roundness === 'small',
            '--roundness-medium': this.roundness === 'medium',
            '--roundness-large': this.roundness === 'large',
            '--roundness-huge': this.roundness === 'huge',
            '--roundness-full': this.roundness === 'full',
            '--object-fit-cover': this.objectFit === 'cover',
            '--object-fit-contain': this.objectFit === 'contain',
            '--bordered': this.bordered,
        }, this.bgColor && getBgColorClass(this.bgColor));
    }
    renderImage(item) {
        if (typeof item === 'string') {
            return html `<img
        src="${item}"
        alt="${this.imgAlt}"
        class="--fade-in-animation-fast"
      />`;
        }
        if (item) {
            return item;
        }
        return null;
    }
    render() {
        const contentIsURL = typeof this.image === 'string';
        const fallbackIsURL = typeof this.fallback === 'string';
        const fallbackClass = !fallbackIsURL ? '--no-image-content' : '';
        const imageClass = !contentIsURL ? '--no-image-content' : '';
        return html `
      <div class="${this.computedClasses}">
        ${this.fallback
            ? html `
              <div class="avatar__cont ${fallbackClass}">
                ${this.renderImage(this.fallback)}
              </div>
            `
            : null}
        ${this.image
            ? html `
              <div class="avatar__cont ${imageClass}">
                ${this.renderImage(this.image)}
              </div>
            `
            : null}
      </div>
    `;
    }
};
HTAvatar.styles = css `
    ${unsafeCSS(css_248z)}
  `;
__decorate([
    property({ type: String })
], HTAvatar.prototype, "image", void 0);
__decorate([
    property({ type: String })
], HTAvatar.prototype, "fallback", void 0);
__decorate([
    property({ type: String })
], HTAvatar.prototype, "size", void 0);
__decorate([
    property({ type: String })
], HTAvatar.prototype, "roundness", void 0);
__decorate([
    property({ type: String, attribute: 'img-alt' })
], HTAvatar.prototype, "imgAlt", void 0);
__decorate([
    property({ type: String, attribute: 'object-fit' })
], HTAvatar.prototype, "objectFit", void 0);
__decorate([
    property({ type: String, attribute: 'bg-color' })
], HTAvatar.prototype, "bgColor", void 0);
__decorate([
    property({ type: Boolean })
], HTAvatar.prototype, "bordered", void 0);
HTAvatar = __decorate([
    customElement('ht-avatar')
], HTAvatar);
var HTAvatar$1 = HTAvatar;

export { HTAvatar, HTAvatar$1 as default };
//# sourceMappingURL=avatar.js.map
